const RaffleManage = () => import('@/views/main/raffle/raffleManage/RaffleManage.vue')
export default {
  path: '/main/raffle/raffleManage',
  name: 'RaffleManage',
  component: RaffleManage
}
